import { PUBLIC_MEETING_ROOM_LIST_MAX_LIMIT } from './constants'
import { PublicMeetingRoomListRequestPayload } from './types'

export const buildPublicMeetingRoomListPayload = (): PublicMeetingRoomListRequestPayload => ({
  filterBy: [
    {
      field: 'is_hidden',
      condition: 'false',
      comparison: 'eq',
    },
  ],
  sort: '',
  limit: PUBLIC_MEETING_ROOM_LIST_MAX_LIMIT,
  page: 1,
  totalRows: 0,
  match: '',
})
